module.exports = __webpack_public_path__ + "img/w51b.ccc1a723.jpg";